import { makeMemberQuery, makeApiMutation } from "@web-monorepo/fetchers";

export const useGroupRestrictionsFetcher = makeMemberQuery({
  fetcherName: "groupRestrictions",
  path: "/api/userConfig/metadata/{metaDataName}",
});

export const useEditGroupRestrictionsMutation = makeApiMutation({
  name: "editGroupRestrictions",
  path: "/api/userConfig/metadata/{metaDataName}",
  method: "put",
  onSuccess: () => {
    useGroupRestrictionsFetcher.invalidateQueries();
  },
});
